import { ArticleHeading4, ArticleParagraph2, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ICPDHomeownerTrapProps {
  onClick: () => void;
}

export const CPDHomeownerTrap: React.FC<ICPDHomeownerTrapProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <ArticleHeading4 color="text-primary-default">Продать быстрее с профи</ArticleHeading4>
          <ArticleParagraph2 color="text-primary-default">
            Подберём опытного риелтора и подключим максимальное продвижение объявления
          </ArticleParagraph2>
        </div>

        <div>
          <Button onClick={onClick} theme="fill_primary" size="M">
            Попробовать
          </Button>
        </div>
      </div>
    </div>
  );
};
